import React, { useState } from "react";
import { useEffect } from "react";
import { withRouter } from "react-router";
import config from "../../services/config.json";
import { getSingleNews } from "../../services/NewsService";
const NewsDetails = ({ match }) => {
  const [NewsDetail, setNewsDetail] = useState({});
  const getNewsDetails = async (id) => {
    try {
      const data = await getSingleNews(match.params.id);
      setNewsDetail(data.data.data);
    } catch (ex) {}
  };

  useEffect(() => {
    try {
      getNewsDetails(match.params.id);
    } catch (ex) {}
  }, [match.params.id]);

  return (
    <section className="blur_bg my-5">
      <div className="container">
        <div className="text-center">
          <h2 className="fw-bold mb-3">{NewsDetail.title}</h2>
          <p>{NewsDetail.second_title}</p>
          <ul className="d-flex justify-content-center">
            {NewsDetail && NewsDetail.cat_list
              ? NewsDetail.cat_list.map((cat, idx) => (
                  <li key={idx} className="badge light_grey mx-2 p-2 fw-light">
                    <a href="" className="text-white">
                      {cat}
                    </a>{" "}
                  </li>
                ))
              : null}
          </ul>
          <img
            src={`${config.vionna}/${NewsDetail.pic_address}`}
            alt=""
            className="bightness_50 img-fluid"
          />
          <div className="row mt-3 text-muted align-items-center">
            <div className="col-lg-6">
              <h6>منتشر شده در تاریخ {NewsDetail.news_date}</h6>
            </div>
            <div className="col-lg-6">
              <p>
                نوشته شده توسط : <span>{NewsDetail.author}</span>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-4">
          <div className="col-lg-1 d-none d-lg-block">
            <ul className="align-items-center d-flex flex-column justify-content-center">
              <li>
                <a href="" className="me-4 link-secondary">
                  <i className="fa fa-telegram "></i>
                </a>
              </li>
              <li>
                <a href="" className="me-4 link-secondary">
                  <i className="fa fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="" className="me-4 link-secondary">
                  <i className="fa fa-mobile"></i>
                </a>
              </li>
              <li>
                <a href="" className="me-4 link-secondary">
                  <i className="fa fa-whatsapp"></i>
                </a>
              </li>
              <li>
                <a href="" className="me-4 link-secondary">
                  <i className="fa fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="" className="me-4 link-secondary">
                  <i className="fa fa-github"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-10 mx-3">
            <h3 className="fw-bold">{NewsDetail.second_title}</h3>
            <p>{NewsDetail.long_text}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withRouter(NewsDetails);
